import ApiClient, { ApiCallError } from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import { HealthGoal, HealthIndicator } from '@src/data/goal'
import { HealthGoalResponse } from '@src/routes/members/components/health-goals/health-goals'
import SessionManager from '@src/lib/session_manager'
import camelcaseKeys from 'camelcase-keys'

export class HealthGoalsService {

  apiClient: ApiClient = new ApiClient()

  constructor () {
    // noop
  }

  getGoalHistory (memberId, date, healthGoalId) {
    return this.apiClient.get((SessionManager.Instance.isManager() ? API.TRAINERS_API.HEALTH_GOAL_HISTORY : API.MEMBERS_API.HEALTH_GOAL_HISTORY)
      .replace('{memberId}', memberId)
      .replace('{date}', date)
      .replace('{healthGoalId}', healthGoalId))
      .then((response: HealthGoalResponse) => {
        let goal = new HealthGoal(camelcaseKeys(response.health_goal, { deep: true }))
        goal.indicators = response.health_goal.indicators.map(indicator => new HealthIndicator(camelcaseKeys(indicator, { deep: true })))
        return Promise.resolve(goal)
      })
      .catch((error: ApiCallError) => {
        if (error.status === 404) return Promise.resolve(null)
        console.log('cannot load health goal history', error)
        return Promise.reject(error)
      })
  }
}
